import React, { useContext } from 'react'
import myContext from '../context/context'
import GetSearchResult from '../../Utility/GetSearchResult/GetSearchResult'
import { loadData, isFilterApplied } from '../../Utility/Utility.js'
// import { AuthContext } from '../../../../context/AuthContext'

const PolygonFilter = () => {

    const { searchCriteria, setSearchCriteria, setSearchResult, setShowSpinner } = useContext(myContext)
    // const keycloak = useContext(AuthContext)

    const removeItem = () => {
        let newSearchCriteria = searchCriteria
        newSearchCriteria.polygon.points = []
        setSearchCriteria(newSearchCriteria)

        setSearchResult({ property: [], totalCount: 0 })

        FetchSearchResult(newSearchCriteria)
    }

    const FetchSearchResult = async newSearchCriteria => {
        if (isFilterApplied(newSearchCriteria)) {
            setShowSpinner(true)

            const searchResult = new GetSearchResult(newSearchCriteria, function () { })
            const response = await searchResult.fetchSearchResult()
            // console.log('response ', response)
            setShowSpinner(false)
            loadData(response, newSearchCriteria, setSearchResult)
        }
    }

    return (
        <>
            {searchCriteria.polygon && searchCriteria.polygon.points.length ?
                <>
                    <div className="capitalize text-primary badge rounded-pill px-5 mr-3 mb-4 py-3 bg-gray-15" >
                        <span className="cursor-context-menu" >
                            Polygon
                        </span>
                        <span data-testid="test-btn-remove-polygon" onClick={() => removeItem()} className="-mr-3">
                            <button type="button">
                                <i className="fa fa-close"></i>
                            </button>
                        </span>
                    </div>
                </>
                : null}
        </>
    )
}

export default PolygonFilter
